import { ACTIONS, COLUMN_TYPE, CONTAS_A_PAGAR_VALUES_DEFAULT } from '../../../../utils/financialHelper';
import FormContasAPagar from './FormContasAPagar';
import useCrud from '../../../../hooks/useCrud';
import CrudTablePage from '../../../../components/Financial/CrudTablePage';

const ContasAPagar = () => {
  const headCells = [
    { key: 'name', field: 'name', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Nome' },
    { key: 'dueDate', field: 'dueDate', type: COLUMN_TYPE.DATE, alignRight: true, label: 'Data de Vencimento' },
    { key: 'status', field: 'status', type: COLUMN_TYPE.STRING, alignRight: true, label: 'Status' },
    { key: 'amount', field: 'amount', type: COLUMN_TYPE.MONEY, alignRight: true, label: 'Valor' },
    { key: 'actions', field: 'actions', type: COLUMN_TYPE.BUTTONS, alignRight: true, label: 'Ações' },
  ];

  const funcionalidade = 'Contas a Pagar'

  const {
    action,
    buttonLabel,
    dadoFoiModificado,
    filterValue,
    isLoading,
    isLoadingSubmit,
    items: contasAPagar,
    open,
    title,
    values,
    setAction,
    setButtonLabel,
    setDadoFoiModificado,
    setFilterValue,
    setItems: setContasAPagar,
    setValues,
    handleClose,
    handleDelete,
    handleEdit,
    handleOpen,
    handleSubmit,
    handleView,
    handleClone,
  } = useCrud('/billings-payable', CONTAS_A_PAGAR_VALUES_DEFAULT, funcionalidade);

  return (
    <CrudTablePage
      isLoading={isLoading}
      funcionalidade={funcionalidade}
      rows={contasAPagar}
      setRows={setContasAPagar}
      headCells={headCells}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      handleClone={handleClone}
      filterValue={filterValue}
      setFilterValue={setFilterValue}
      dadoFoiModificado={dadoFoiModificado}
      setDadoFoiModificado={setDadoFoiModificado}
      open={open}
      title={title}
      buttonLabel={buttonLabel}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      action={action}
      handleOpen={handleOpen}
    >
      <FormContasAPagar
        values={values}
        setValues={setValues}
        isDelete={action === ACTIONS.DELETE}
        isLoadingSubmit={isLoadingSubmit}
      />
    </CrudTablePage>
  )
};

export default ContasAPagar;